// Copyright (C) 2020 TANNER AG

import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Navigation from "../layouts/Navigation";
import Heading2 from "../styleguide/Heading2";
import withPageInfo from "../hocs/withPageInfo";
import withPodcast from "../hocs/withPodcast";
import { SmallText } from "../styleguide";
import { Markdown } from "../components";
import { getImageComponent } from "../components/PodcastsItem";
import formatDateTime from "../utils/formatDateTime";
import PodcastsKeyword from "../components/PodcastsKeyword";
import PodcastsMedia from "../components/PodcastsMedia";

const styles = (theme) => ({
    containerStyle: {
        flex: "1 0 auto",
        padding: "0 36px 100px 36px",
        background: "#fafafa",
    },
    gridStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
    },
    contentContainerStyle: {
        marginTop: 85,
    },
    headingStyle: {
        marginBottom: 20,
    },
    kickerStyle: {
        color: "#838a92",
        marginBottom: 5,
    },
    cardMediaWrapperStyle: {
        minWidth: 102,
        width: 102,
        height: 102,
        marginRight: "1rem",
    },
    contentStyle: {
        display: "flex",
        flexGrow: 1,
        paddingBottom: "4px",
        width: "100%",
    },
    audio: {
        maxWidth: 400,
        width: "100%",
        marginTop: 30,
    },
    keywords: {
        display: "inline-block",
        marginLeft: 12,
    },
});

const Podcast = (props) => {
    const { classes, setPageInfo, podcast } = props;
    const image = getImageComponent(podcast.teaserImage);
    const [formattedDate] = formatDateTime(podcast.publicationDate);

    useEffect(() => {
        setPageInfo({ title: podcast.title });
    }, []);

    const getMedia = () => {
        let url = "";

        if (podcast.mediaUrl) {
            url = podcast.mediaUrl;
        } else if (podcast.media) {
            url = podcast.media.url;
        }

        return <PodcastsMedia mimeType={podcast.mediaType || ""} url={url} />;
    };

    return (
        <div className={classes.containerStyle}>
            <Grid container spacing={0} className={classes.gridStyle}>
                <Navigation enableOverviewShortcuts={false} />
                <Grid item xs={12} md={8} className={classes.contentContainerStyle}>
                    <SmallText className={`${classes.kickerStyle} intro-section-kicker`}>BusCast</SmallText>
                    <Heading2 className={classes.headingStyle}>{podcast.title}</Heading2>
                    <div className={classes.contentStyle}>
                        <div className={classes.cardMediaWrapperStyle}>{image}</div>
                        <div>
                            <SmallText className={classes.kickerStyle}>
                                {formattedDate}
                                {Boolean(podcast.keywords && podcast.keywords.length) && (
                                    <div className={classes.keywords}>
                                        {podcast.keywords.split("|").map((keyword) => (
                                            <PodcastsKeyword key={keyword} label={keyword} />
                                        ))}
                                    </div>
                                )}
                            </SmallText>
                            <Markdown source={podcast.description} />
                            {getMedia()}
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            id: params.id,
        };
    }),
    withPodcast(),
    withStyles(styles),
    withPageInfo
)(Podcast);



// WEBPACK FOOTER //
// ./src/screens/Podcast.js